import * as React from "react";
const SvgFiRrMosqueAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mosque-alt_svg__a)">
      <path
        fill="#062147"
        d="M23 22V8a1 1 0 1 0 0-2V5a3 3 0 0 0-2-2.816V1a1 1 0 1 0-2 0v1.184A3 3 0 0 0 17 5v1a1 1 0 1 0 0 2v14h-4v-4.064c1.273-1.146 2-2.537 2-3.88 0-3.265-2.88-4.719-4.786-5.681-.636-.321-1.597-.806-1.714-1.01V6a1 1 0 1 0-2 0v1.325c-.165.267-1.094.736-1.714 1.05C2.88 9.337 0 10.791 0 14.056c0 1.323.743 2.741 2 3.88V22H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2M19 5a1.001 1.001 0 0 1 2 0v1h-2zm0 3h2v14h-2zM5.687 10.16c.662-.334 1.308-.66 1.813-1.047.505.387 1.15.712 1.812 1.047C11.471 11.25 13 12.167 13 14.056c0 .611-.336 1.317-.907 1.963-.032-.003-9.154-.003-9.186 0C2.336 15.372 2 14.667 2 14.056c0-1.889 1.528-2.806 3.687-3.896M4 18h7v4H4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mosque-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMosqueAlt;
